// ============================================================================
// SLA STATUS — single source of truth for Live Fires warn/critical escalation
//
// Every Queue Health card escalates to warn/critical based on the SHARE of its
// queue that is stuck (not raw counts), with a minimum stuck count so tiny
// queues don't flip to critical on a single item.
//
// Used by Ops Manager Dashboard, Ops Home, and Triage Queue Health so the same
// queue produces the same status everywhere.
// ============================================================================

/**
 * @param {number} stuckCount  items breaching SLA
 * @param {number} queueCount  total items in the queue
 * @param {number} warnPct     warn threshold as a ratio (e.g. 0.10)
 * @param {number} critPct     critical threshold as a ratio (e.g. 0.25)
 * @param {number} [minWarn=2] minimum stuck items before warn can trigger
 * @param {number} [minCrit=3] minimum stuck items before critical can trigger
 * @returns {'ok'|'warn'|'critical'}
 */
export function queueSlaStatus(stuckCount, queueCount, warnPct, critPct, minWarn = 2, minCrit = 3) {
  if (queueCount === 0 || stuckCount === 0) return 'ok';
  const ratio = stuckCount / queueCount;
  if (ratio >= critPct && stuckCount >= minCrit) return 'critical';
  if (ratio >= warnPct && stuckCount >= minWarn) return 'warn';
  return 'ok';
}
